import { UserCard } from '@/entities/user'
import { IUser } from '@/entities/user/model/types'
import PerUsd from '@/features/per-usd/ui/per-usd'
import { DEFAULT_PREC } from '@/shared/lib'
import useNotifier from '@/shared/lib/use-notifier'
import useRequest from '@/shared/lib/use-request'
import { LangStore } from '@/shared/model/store'
import { ContractsStore } from '@/shared/model/store/contracts-store'
import { Button } from '@/shared/ui'
import { AmountBlock } from '@/shared/ui/amount-block/amount-block'
import LoadingIcon from '@/shared/ui/loading-icon'
import { ethers } from 'ethers'
import { useEffect, useState } from 'react'
import { useAccount } from 'wagmi'

const CreateNpo = () => {
	const { fetch, result } = useRequest<IUser[]>('listNpo')

	const { address: wagmiAdress } = useAccount()
	const { langPack } = LangStore()
	const { contracts } = ContractsStore()
	const [predictedAddress, setPredictedAddress] = useState<`0x${string}`>()

	const { writeContract, isLoading } = useNotifier({
		onSuccess() {
			window.location.href = `/npo/${predictedAddress}`
		}
	})

	const address = wagmiAdress || `0x${'0'.repeat(40)}`

	const createNPO = async () => {
		const implementation = contracts.SavvaNPO.address // Адрес оригинального SavvaNPO
		const salt = ethers.encodeBytes32String(Date.now().toString())

		const minimalProxyBytecode =
			'0x3d602d80600a3d3981f3' +
			'363d3d373d3d3d363d73' +
			implementation.slice(2).toLowerCase() +
			'5af43d82803e903d91602b57fd5bf3'

		const initCodeHash = ethers.keccak256(minimalProxyBytecode)

		const inputBytes = ethers.concat([
			ethers.getBytes('0xff'),
			ethers.getBytes(contracts.SavvaNPOFactory.address),
			ethers.getBytes(salt),
			ethers.getBytes(initCodeHash)
		])

		const fullHash = ethers.keccak256(inputBytes)
		const pa = ethers.getAddress('0x' + fullHash.slice(-40))

		setPredictedAddress(pa as `0x${string}`)
		writeContract({
			abi: contracts.SavvaNPOFactory.abi,
			address: contracts.SavvaNPOFactory.address,
			functionName: 'cloneSavvaNPODeterministic',
			args: [salt, address]
		})
	}

	useEffect(() => {
		fetch({
			params: {
				confirmed_only: false,
				limit: 100
			}
		})
	}, [])

	return (
		<>
			<div className='flex flex-col items-center rounded-lg border-2 border-dashed p-4'>
				<span className='mb-2 font-semibold'>{langPack('npo.title')}</span>
				{predictedAddress ? (
					<div className='mt-4 text-center text-[12px] text-[grey]'>
						<p>{langPack('npo.progressMessage')}</p>
						<p>{langPack('npo.creating')}</p>
						<p>
							{langPack('npo.futureContractAddress')}: {predictedAddress}
						</p>
						<LoadingIcon />
					</div>
				) : (
					<Button
						onClick={createNPO}
						loading={isLoading}
						variant={'orange'}
						className='w-[320px]'
						disabled={!wagmiAdress}
					>
						{langPack('npo.createButton')}
					</Button>
				)}
			</div>
			<div className='mt-4 flex flex-col gap-4'>
				{result &&
					result.map((el: IUser) => (
						<div className='flex w-full justify-between rounded-lg bg-background p-4 shadow-md'>
							<UserCard user={el} length={100} />
							<div className='flex flex-row'>
								<div className='flex w-[150px] flex-col items-center justify-center'>
									<div className='text-[grey]'>{langPack('staking.stake_balance')}</div>
									<div className='flex flex-row items-end gap-2'>
										<AmountBlock amount={el.staked} size='sm' />
										{el.total_sponsored ? (
											<PerUsd
												amount={el.total_sponsored / DEFAULT_PREC}
												token='SAVVA'
												bracket
												className='text-[12px] text-[gray]'
											/>
										) : null}
									</div>
								</div>
								<div className='flex w-[150px] flex-col items-center justify-center'>
									<div className='text-[grey]'>{langPack('profile.sponsors_users')}</div>
									<div className='flex flex-row items-end gap-2'>
										<AmountBlock amount={el.total_sponsoring} size='sm' />
										{el.total_sponsoring ? (
											<PerUsd
												amount={el.total_sponsoring / DEFAULT_PREC}
												token='SAVVA'
												bracket
												className='text-[12px] text-[gray]'
											/>
										) : null}
									</div>
								</div>
								<div className='flex w-[150px] flex-col items-center justify-center'>
									<div className='text-[grey]'>{langPack('profile.sponsor_other')}</div>
									<div className='flex flex-row items-end gap-2'>
										<AmountBlock amount={el.total_sponsored} size='sm' />
										{el.total_sponsored ? (
											<PerUsd
												amount={el.total_sponsored / DEFAULT_PREC}
												token='SAVVA'
												bracket
												className='text-[12px] text-[gray]'
											/>
										) : null}
									</div>
								</div>
								<div className='flex w-[150px] flex-col items-center justify-center'>
									<div className='text-[grey]'>{langPack('npo.members')}</div>
									<div className='flex flex-row items-end gap-2'>
										<AmountBlock amount={el.confirmed_members * DEFAULT_PREC} size='sm' withoutIcon />
									</div>
								</div>
							</div>
						</div>
					))}
			</div>
		</>
	)
}

export default CreateNpo
